module.exports = __webpack_public_path__ + "assets/GoldPsi2x.bb01097bd1a338ed0a10a7e2395e7710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldPsi2x.png
// module id = 820
// module chunks = 0